import React, { useContext } from 'react';
import SelectCategory from './SelectCategory';
import { CSVContext } from '../../../../../Context/CSVContext';
import SelectImages from './SelectImages';
import DownloadCSV from './DownloadCSV';

function CreateCSV() {
    const { createCSVPage } = useContext(CSVContext);

    return (
        <>
            {createCSVPage === 'category' && <SelectCategory />}

            {createCSVPage === 'images' && <SelectImages />}

            {createCSVPage === 'download' && <DownloadCSV />}
        </>
    );
}

export default CreateCSV;
